<div style="height: 100%; background-color: #000000">
  <img
    src="{{ data.image_list[data.image_index] }}"
    style="object-fit: contain; width: 100%; height: 100%"
  />
  <div class="left">
    <button mat-fab color="basic" (click)="fnBack(data.image_index)">
      <mat-icon>arrow_back_ios</mat-icon>
    </button>
  </div>
  <div class="right">
    <button mat-fab color="basic" (click)="fnNext(data.image_index)">
      <mat-icon>arrow_forward_ios</mat-icon>
    </button>
  </div>
</div>
